import { Col, Dropdown, Pagination, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import dropdownIcon from 'assets/images/arrow-down-white.svg'
import top1Icon from 'assets/images/rankpage-top1.svg'
import top2Icon from 'assets/images/rankpage-top2.svg'
import top3Icon from 'assets/images/rankpage-top3.svg'
import { useQuery } from 'react-query'
import { getRankQuery } from 'dataLayer/game'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import {
	createColumnHelper,
	getCoreRowModel,
	getFilteredRowModel,
	getPaginationRowModel,
	useReactTable,
} from '@tanstack/react-table'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import tableCoinIcon from 'assets/images/coin.svg'
import { hidePhoneNumberMiddle } from 'utils/helpers'

// export const RANKING = {
// 	day: 'Today',
// 	week: 'Week',
// 	month: 'Month',
// }

function RankListMobile({
	playGame,
	totalCount,
	onChangePageSize,
	pageIndex = 0,
	onChangePage,
}) {
	const { t } = useTranslation()
	const [paramGetRank, setParamGetRank] = useState({
		offset: 0,
		limit: 10,
	})

	const RANKING = {
		1: `${t('profile.gift_hist.today')}`,
		2: `${t('profile.gift_hist.this_week')}`,
		3: `${t('profile.gift_hist.this_month')}`,
	}
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)

	const [time, setTime] = useState(1)
	useEffect(() => {
		if (playGame) {
			setTime(Object.keys(RANKING)[2])
		}
	}, [])

	const { data: rank } = useQuery(
		getRankQuery(time, paramGetRank.offset, paramGetRank.limit),
	)
	let listRank = (rank && rank?.filter(it => it.coin_win !== 0)) || []
	const dataRank = listRank?.map(it => {
		it.msisdn = hidePhoneNumberMiddle(it.msisdn)
		return it
	})

	const columnHelper = createColumnHelper()

	const columns = [
		columnHelper.accessor('id', {
			cell: info => {
				const orderId = parseInt(info.row.id) + 1
				return orderId === 1 ? (
					<img src={top1Icon} width="32" alt="Top 1" />
				) : orderId === 2 ? (
					<img src={top2Icon} width="32" alt="Top 2" />
				) : orderId === 3 ? (
					<img src={top3Icon} width="32" alt="Top 3" />
				) : (
					orderId
				)
			},
			header: () => <span>{t('rankpage.table.rank')}</span>,
			footer: info => info.column.id,
		}),
		columnHelper.accessor(row => row.msisdn, {
			id: t('rankpage.table.player'),
			cell: info => info.getValue(),
			header: () => <span>{t('rankpage.table.player')}</span>,
			footer: info => info.column.id,
		}),
		columnHelper.accessor(row => row.coin_win, {
			id: t('rankpage.table.gold'),
			cell: info => {
				return (
					<div className="betcoin-container">
						<div style={{ display: 'flex', marginLeft: '43%' }}>
							<img src={tableCoinIcon} width="20" alt="Bet's coin" />
							<p style={{ marginLeft: '15%' }}>
								{new Intl.NumberFormat('lo').format(info.getValue())}
							</p>
						</div>
					</div>
				)
			},
			header: () => <span>{t('rankpage.table.gold')}</span>,
			footer: info => info.column.id,
		}),
		columnHelper.accessor(row => `${row.total_win}/${row.total_lose}`, {
			id: t('rankpage.table.winrate'),
			cell: info => info.getValue(),
			header: () => <span>{t('rankpage.table.winrate')}</span>,
			footer: info => info.column.id,
		}),
	]
	const table = useReactTable({
		dataRank,
		columns: columns,
		// Pipeline
		getCoreRowModel: getCoreRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		//
		debugTable: true,
	})

	const { pageSize } = table.getState().pagination
	const totalRoomList = totalCount ? totalCount : table.options.dataRank?.length
	return (
		<Row
			style={{ display: 'block' }}
			className={`profilepage-content__body table-height invitation   body mobile  py-2 px-3 px-sm-3 rounded-0 ${playGame ? 'play-game' : ''
				}`}
		>
			{playGame ? null : (
				<Dropdown
					align="end"
					className="profilepage-content__body introduce-dropdown my-1"
				>
					<Dropdown.Toggle>{RANKING[time]}</Dropdown.Toggle>
					<Dropdown.Menu align="end">
						<Dropdown.Item onClick={() => setTime(Object.keys(RANKING)[0])}>
							{t('rankpage.day')}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => setTime(Object.keys(RANKING)[1])}>
							{t('rankpage.week')}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => setTime(Object.keys(RANKING)[2])}>
							{t('rankpage.month')}
						</Dropdown.Item>
					</Dropdown.Menu>
					<img src={dropdownIcon} alt="Rank filter" />
				</Dropdown>
			)}
			<Row
				className={`profilepage-content__body  invitation ${!isMobileMD ? 'cpt' : ''
					} header mx-auto my-2 py-0 px-0 px-sm-3 ${playGame ? 'play-game-header' : ''
					} rank-page-mobile `}
				style={{ height: 40, zIndex: '-1', border: 'none' }}
			>
				<Col xs={3} style={{ fontSize: 12 }}>
					{t('rankpage.table.rank')}
				</Col>
				<Col xs={3} className="ps-0" style={{ fontSize: 12 }}>
					{t('rankpage.table.player')}
				</Col>
				<Col xs={3} className="ps-0" style={{ fontSize: 12 }}>
					{t('rankpage.table.gold')}
				</Col>
				<Col xs={3} className="text-end" style={{ fontSize: 12 }}>
					{t('rankpage.table.winrate')}
				</Col>
			</Row>
			{dataRank?.length > 0 ? (
				dataRank?.map((item, index) => {
					return (
						<div
							key={index}
							style={{ padding: 0 }}
							className="rank-page-mobile-body d-flex align-items-center py-2  px-sm-4 "
						>
							<Col xs={3} style={{ textAlign: 'center' }}>
								{index === 0 ? (
									<img style={{ margin: 'auto' }} src={top1Icon} alt="Top 1" />
								) : index === 1 ? (
									<img style={{ margin: 'auto' }} src={top2Icon} alt="Top 2" />
								) : index === 2 ? (
									<img style={{ margin: 'auto' }} src={top3Icon} alt="Top 3" />
								) : (
									index + 1
								)}
							</Col>
							<Col xs={3} className="friend-info-rank friend-info">
								<p style={{ fontSize: 12 }}>
									{item?.name_ingame ?? item?.msisdn}
								</p>
							</Col>
							<Col xs={3} className="inviter-bet">
								<p
									style={{
										fontSize: 12,
										textAlign: 'start',
										marginLeft: '30%',
									}}
								>
									{new Intl.NumberFormat('lo').format(item?.coin_win)}
								</p>
							</Col>
							<Col xs={3} className="inviter-interact">
								<p>
									{item?.total_win}/{item?.total_lose}
								</p>
							</Col>
						</div>
					)
				})
			) : (
				<img
					style={{ width: '40%', margin: 'auto' }}
					src={noDataIcon}
					alt="No reward is found"
				/>
			)}

			<div
				className="d-flex justify-content-between align-items-center mt-3"
				style={{ border: 'none' }}
			>
				<div
					className="pagination-pagesize d-flex"
					style={{ 'grid-gap': '10px', gap: '10px', 'align-items': 'center' }}
				>
					<select
						value={pageSize}
						onChange={e => {
							if (onChangePageSize instanceof Function)
								onChangePageSize(Number(e.target.value))
							table.setPageSize(Number(e.target.value))
							setParamGetRank({ ...paramGetRank, limit: e.target.value })
						}}
					>
						{[10, 20, 30, 40, 50].map(pageSize => (
							<option key={pageSize} value={pageSize}>
								{pageSize}
							</option>
						))}
					</select>
					<span>
						<div>
							{t('room.table.pagination')
								.replace('_FIRSTROOM_', `${pageIndex * pageSize + 1}`)
								.replace(
									'_LASTROOM_',
									`${totalRoomList >= pageIndex * pageSize + pageSize
										? pageIndex * pageSize + pageSize
										: totalRoomList % ((pageIndex + 1) * pageSize)
									}`,
								)
								.replace('_TOTALROOM_', `${totalRoomList}`)}
						</div>
					</span>
				</div>
				<Pagination
					className="pagination-bar"
					currentPage={pageIndex}
					totalCount={totalRoomList}
					pageSize={pageSize}
					table={table}
					onChangePage={onChangePage}
				/>
			</div>
		</Row>
	)
}

export default RankListMobile
